import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CalendarDaysIcon } from 'lucide-react';
import { HERO_IMAGE, events } from '../../data/site';
import { Sparkle } from '../Sparkle';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  const next = events[0];
  return <section className="relative isolate overflow-hidden bg-nuit text-creme" data-id="element-129" data-mp="eplvp7rw9gxe">
      <img src={HERO_IMAGE} alt="Spectacle son et lumière des Magiciens de la Nuit, le public réuni sous les lanternes" className="absolute inset-0 h-full w-full object-cover" data-id="element-130" data-mp="aplc78pxufjh" />
      <div className="absolute inset-0 bg-nuit/75" data-id="element-131" data-mp="r5hywvm6q5r" />

      <Sparkle className="absolute -right-10 top-10 h-64 w-64 opacity-30 md:right-24 md:h-80 md:w-80" color="#F2B134" data-id="element-132" data-mp="3rwx3tk2czgmr" />

      <div className="relative mx-auto grid max-w-7xl gap-12 px-6 py-20 md:py-28 lg:grid-cols-[1.15fr_0.85fr] lg:items-end" data-id="element-133" data-mp="1v33t54dhhw4a">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} data-id="element-134" data-mp="1q37lmv5kvmjz">
          <p className="text-sm font-semibold text-soleil" data-id="element-135" data-mp="1rw72mewzy8lb">
            Association culturelle en pays de Caux — depuis 1989
          </p>
          <h1 className="mt-4 max-w-2xl font-display text-4xl font-bold leading-[1.08] sm:text-5xl lg:text-6xl" data-id="element-136" data-mp="1d0j1wzqw03m6">
            La culture qui éclaire
            <br data-id="element-137" data-mp="25nvdkevier0p" />
            le quotidien.
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-creme/80" data-id="element-138" data-mp="2alx7xvydycrh">
            Chorale, théâtre, poterie, ciné-club et grands spectacles son et lumière : chacun
            apporte sa lumière, et le village s’allume. Venez chanter, jouer, créer — ou simplement
            partager la soirée.
          </p>
          <div className="mt-9 flex flex-wrap gap-3" data-id="element-139" data-mp="2oly4x0bj501o">
            <a href="#activites" className="inline-flex items-center gap-2 rounded-full bg-soleil px-6 py-3 font-semibold text-nuit transition-colors duration-150 ease-out hover:bg-braise hover:text-white" data-id="element-140" data-mp="2okdenmw9039m">
              Découvrir nos activités
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-141" data-mp="2y9ts3d28ds9h" />
            </a>
            <a href="#agenda" className="inline-flex items-center gap-2 rounded-full border border-creme/30 px-6 py-3 font-semibold text-creme transition-colors duration-150 ease-out hover:border-soleil hover:text-soleil" data-id="element-142" data-mp="2u6dw8ixzjvxu">
              <CalendarDaysIcon className="h-4 w-4" aria-hidden="true" data-id="element-143" data-mp="2fj2l2i5pudy9" />
              Voir l’agenda
            </a>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: EASE
      }} className="lg:justify-self-end" data-id="element-144" data-mp="2ak99iv9zox0q">
          <Link to="/cine-club" className="group block max-w-sm rounded-3xl bg-creme/95 p-6 text-nuit shadow-soft transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-145" data-mp="21kvw5riqvoaq">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-braise" data-id="element-146" data-mp="h10ksfyeqrec">
              Prochain rendez-vous
            </p>
            <div className="mt-4 flex items-center gap-4" data-id="element-147" data-mp="m1ernuo9vvas">
              <div className="flex h-16 w-16 shrink-0 flex-col items-center justify-center rounded-2xl bg-nuit text-creme" data-id="element-148" data-mp="q1f63fbdg6hu">
                <span className="font-display text-xl font-bold leading-none" data-id="element-149" data-mp="3phlmdbopmi7f">{next.day}</span>
                <span className="text-[11px] uppercase" data-id="element-150" data-mp="3uf3wh5egr3h0">{next.month}</span>
              </div>
              <div data-id="element-151" data-mp="2bkx58u6b22v">
                <p className="font-display text-lg font-semibold leading-snug" data-id="element-152" data-mp="2bb1p5qd02ps">{next.title}</p>
                <p className="text-sm text-nuit/60" data-id="element-153" data-mp="73up0ueumc7s">
                  {next.category} · {next.time}
                </p>
              </div>
            </div>
            <p className="mt-4 text-sm text-nuit/70" data-id="element-154" data-mp="3arwdsveafbx4">{next.place}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-braise" data-id="element-155" data-mp="3aq393ln8j1rr">
              En savoir plus
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-156" data-mp="2mo7w11d9g8lf" />
            </span>
          </Link>
        </motion.div>
      </div>
    </section>;
}